var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7,
    viewBox: "0 0 24 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    d: "M.813 1.518a.599.599 0 011.022-.423l10.352 10.353L22.54 1.095a.599.599 0 11.847.846L12.611 12.718a.599.599 0 01-.847 0L.988 1.94a.597.597 0 01-.175-.423z"
  })));
}

export default SvgFilterChevron;